export const BRAND_ASSETS = {
  logoFull: `${process.env.PUBLIC_URL}/veriplan-logo-complet.svg`,
  wordmark: `${process.env.PUBLIC_URL}/veriplan-wordmark.svg`,
  iconMini: `${process.env.PUBLIC_URL}/veriplan-icon-mini.svg`,
  iconBadge: `${process.env.PUBLIC_URL}/veriplan-badge-square.svg`,
};
